import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useImperativeHandle } from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypePrism from '@mapbox/rehype-prism';
import "./styles/markdown.css";
import "./styles/markdowncolor.css";
export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _ref = props || {},
    className = _ref.className,
    source = _ref.source,
    style = _ref.style,
    onScroll = _ref.onScroll,
    onMouseOver = _ref.onMouseOver,
    _ref$warpperElement = _ref.warpperElement,
    warpperElement = _ref$warpperElement === void 0 ? {} : _ref$warpperElement,
    other = _objectWithoutProperties(_ref, ["className", "source", "style", "onScroll", "onMouseOver", "warpperElement"]);
  var mdp = /*#__PURE__*/React.createRef();
  useImperativeHandle(ref, function () {
    return _objectSpread(_objectSpread({}, props), {}, {
      mdp: mdp
    });
  }, [mdp, props]);
  var cls = "wmde-markdown wmde-markdown-color ".concat(className || '');
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: mdp,
    onScroll: onScroll,
    onMouseOver: onMouseOver
  }, warpperElement, {
    className: cls,
    style: style
  }), /*#__PURE__*/React.createElement(ReactMarkdown, _extends({}, other, {
    plugins: [gfm].concat(_toConsumableArray(other.plugins || [])),
    rehypePlugins: [[rehypePrism, {
      ignoreMissing: true
    }], rehypeRaw].concat(_toConsumableArray(other.rehypePlugins || [])),
    children: source || ''
  })));
});